import { assert } from './assert';

export function getAttrKey(attrName: string): string {
  const attr = attrName.split('.').at(-1);

  assert(attr, 'attr is not presented');

  return attr;
}
